export const PRIVATE_ACCESS_PATH_REGEX = /^\/(me|watch|checkout|subscribe)/
export const PUBLIC_ACCESS_PATH_REGEX =
  /^\/(tos|privacy|cookies|subscribe|me\/profile\/create)/
